module.exports = __webpack_public_path__ + "static/screen-3@3x-313cddc97f94e1eb0947d78d5d4b1caf.png";